<p-dialog [(visible)]="displayDialog" [style]="{width: '50vw', minHeight: 'auto', maxHeight: '80vh'}" [modal]="true"
  [draggable]="false" [resizable]="false" (onHide)="onDialogClosed()"
  [header]="esEdicion ? 'Editar Script' : 'Nuevo Script'">

  <form [formGroup]="form" (ngSubmit)="onSubmit()" appPermissionControl="P276F0001">
    <div class="form-row">
      <div class="form-field">
        <input pInputText type="text" formControlName="sClaveCues" class="form-control"
          [placeholder]="cuestionario?.sClaveCues" disabled appPermissionControl="P276K0001">
        <label>Clave Cuestionario</label>
      </div>
      <div class="form-field">
        <input pInputText type="number" formControlName="iNumPreg" class="form-control"
          [placeholder]="preguntaSeleccionada?.iNumPreg" disabled appPermissionControl="P276K0002">
        <label>N° Pregunta</label>
      </div>
      <div class="form-field">
        <input pInputText type="number" formControlName="iNumOpcion" class="form-control"
          [placeholder]="opcionSeleccionada?.iNumOpcion" disabled appPermissionControl="P276K0003">
        <label>N° Opción</label>
      </div>
    </div>

    <div class="form-row">
      <div class="form-field">
        <input pInputText type="number" formControlName="iNumScript" class="form-control" placeholder="N° Script"
          [disabled]="esEdicion" appPermissionControl="P276K0004">
        <label>N° Script</label>
      </div>
    </div>

    <div class="form-row">
      <div class="form-field">
        <textarea pInputTextarea formControlName="sComentario" class="form-control" rows="3" placeholder="Comentario" appPermissionControl="P276K0005"></textarea>
        <label>Comentario</label>
      </div>
    </div>

    <div class="button-section mt-3">
      <button mat-flat-button class="btn-success btn-menu" type="submit" [disabled]="!form.valid || loading" appPermissionControl="P276B0001">
        <mat-icon *ngIf="!loading">save</mat-icon>
        <p-progressSpinner *ngIf="loading" styleClass="w-4rem h-4rem" strokeWidth="8" fill="var(--surface-ground)"
          animationDuration=".5s"></p-progressSpinner>
        {{ esEdicion ? 'Actualizar' : 'Guardar' }}
      </button>
    </div>
  </form>
</p-dialog>

<p-toast position="bottom-right"></p-toast>